import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const StaffAppReleases = lazy(() => import('./StaffAppReleases'));
const StaffAppReleasesListView = lazy(() => import('./views/StaffAppReleasesListView'));
const StaffAppReleaseDetailView = lazy(() => import('./views/StaffAppReleaseDetailView'));
const UploadStaffReleaseForm = lazy(() => import('./views/UploadStaffReleaseForm'));

const StaffAppReleasesRoute: FuseRouteItemType = {
	path: '/staff-app/releases',
	element: <StaffAppReleases />,
	auth: ['Admin'],
	children: [
		{ index: true, element: <StaffAppReleasesListView /> },
		{ path: 'upload', element: <UploadStaffReleaseForm /> },
		{ path: ':id', element: <StaffAppReleaseDetailView /> },
		{ path: ':id/edit', element: <StaffAppReleaseDetailView /> }
	]
};

export default StaffAppReleasesRoute;
